// validators.ts for Gantt

import * as _ from 'underscore';

const validCellDurationValues = [10, 15, 30, 60, 120, 180, 240, 360, 720, 1440];

export const validators = {
    DST_SwitchingDays: {
        dst_shouldHaveYear: function (value) {
            let find = _.find<any>(value, (obj: any) => {
                return obj.year == null;
            });

            if (find != null) {
                return ['Year must be specified for all items'];
            }
        },
        //LL: I presume that a Year cannot have 2 Summer periods:
        dst_yearsUnique: function (value) {
            let count = _.countBy<any>(
                value,
                //(obj) => { return obj.name || ' '; }
                (obj: any) => {
                    //LL: allow repeate for "another" items ( = inherited from upper, ex Workspace)
                    if (obj.another === true) return; // key === "undefined"
                    let year = obj.year;
                    if (year == null) {
                        year = -1;
                    }
                    return year;
                }
            );
            let find = _.find<any>(count, (num, key) => {
                if (key === 'undefined') return false;
                return num > 1;
            });
            if (find != null) {
                return ['Years should be different for all items'];
            }
        },
        //LL: My supposition was that both toSummer and toWinter must be set. But I was wrong
        // A Year can have only 1 switching date: to Summer or to Winter - an example is our MSK:
        //   in 2011 there was only switch to Summer on 27.03.2011
        //   in 2014 only switch to Winter
        dst_shouldHaveDates: function (value) {
            //let find = _.find<any>(value, (obj: any) => {
            //    return (obj.year != null && (obj.toSummerDate == null || obj.toWinterDate == null));
            //});
            //
            //if (find != null) {
            //    return ['Dates must be specified for all defined Years'];
            //}
            let find = _.find<any>(value, (obj: any) => {
                return obj.year != null && obj.toSummerDate == null && obj.toWinterDate == null;
            });

            if (find != null) {
                return ['At least one Date (ToSummer or ToWinter) must be specified for all defined Years'];
            }
        },
        dst_differentDates: function (value) {
            let find = _.find<any>(value, (obj: any) => {
                let toSummerDate = obj.toSummerDate;
                if (obj.toSummerDate != null && typeof obj.toSummerDate === 'string') {
                    toSummerDate = new Date(obj.toSummerDate);
                }
                let toWinterDate = obj.toWinterDate;
                if (obj.toWinterDate != null && typeof obj.toWinterDate === 'string') {
                    toWinterDate = new Date(obj.toWinterDate);
                }
                return (
                    toSummerDate != null && toWinterDate != null && toSummerDate.getTime() === toWinterDate.getTime()
                );
                //return (obj.toSummerDate != null && obj.toWinterDate != null && obj.toSummerDate.getTime() === obj.toWinterDate.getTime());
            });

            if (find != null) {
                return ['ToSummer and ToWinter Dates cannot be equal'];
            }
        }
    },

    cell_duration: {
        validMinutes: function (value) {
            let find = _.find<any>(validCellDurationValues, (val) => {
                return val === value;
            });
            if (find == null) {
                return ['Value should be one of ' + validCellDurationValues];
            }
        }
    },

    attrquery_scheduler: {
        shouldHaveDisplay: function (value) {
            let find = _.find<any>(value, (obj) => {
                return obj.display == null || obj.display === 'none';
            });

            if (find != null) {
                return ['"Display" should be specified for all Attributes'];
            }
        },

        displayUnique_resourceLink: function (ResourceNameList) {
            return function (value) {
                //  actually, it is array now, not func
                let nameList;
                if (typeof ResourceNameList === 'function') {
                    nameList = ResourceNameList();
                } else {
                    nameList = ResourceNameList;
                }

                if (nameList == null) {
                    return;
                }

                //text: "link to group: " + title + "(2)",
                //val: title + "_2",
                //LL:  linkIndex ? no
                let count = _.countBy<any>(
                    value,
                    (obj: any) => {
                        if (obj.linkIndex != null && obj.linkIndex !== 1 && obj.valBase != null) {
                            return obj.valBase + '(' + obj.linkIndex + ')';
                        } else {
                            return obj.display || 'none';
                        }
                    }
                );

                let find = _.find<any>(nameList, (resName) => {
                    if (count[resName] == null) {
                        return false;
                    }
                    return count[resName] > 1;
                });

                if (find != null) {
                    return ['Display value for Link to Group "' + find + '" can be set only once'];
                }
            };
        },

        displayUnique: function (vals, DisplayList) {
            return function (value) {
                let count = _.countBy<any>(value, (obj) => {
                    return obj.display || 'none';
                });

                let find = _.find<any>(vals, (val) => {
                    if (count[val] == null) {
                        return false;
                    }
                    return count[val] > 1;
                });

                if (find != null) {
                    if (DisplayList[find] != null) {
                        find = '"' + DisplayList[find] + '"';
                    }

                    return ['Display value ' + find + ' can be set only once'];
                }
            };
        },

        displayRequire: function (vals, DisplayList) {
            return function (value) {
                let count = _.countBy<any>(value, (obj) => {
                    return obj.display || 'none';
                });

                let find = _.find<any>(vals, (val) => {
                    if (count[val] == null) {
                        return true;
                    }
                    return count[val] === 0;
                });

                if (find != null) {
                    if (DisplayList[find] != null) {
                        find = '"' + DisplayList[find] + '"';
                    }
                    return ['Display value ' + find + ' must be specified'];
                }
            };
        },

        isDate: function (val, DisplayList) {
            return function (value) {
                let find = _.find<any>(value, (obj) => {
                    if (obj.display === val) {
                        let at = obj.attrType;
                        if (!(at === 'datetime' || at === 'date' || at === 'time')) {
                            return true;
                        }
                    }
                });

                if (find != null) {
                    let disp = find.display;
                    if (DisplayList[disp] != null) {
                        disp = '"' + DisplayList[disp] + '"';
                    }
                    return ['Attribute Type for ' + disp + ' must be Date, but is "' + find.attrType + '"'];
                }
            };
        },

        resource_roleUnique: function (vals) {
            return function (value) {
                let count = _.countBy<any>(value, (obj) => {
                    return obj.role || 'none';
                });

                let find = _.find<any>(vals, (val) => {
                    if (count[val] == null) {
                        return false;
                    }
                    return count[val] > 1;
                });

                if (find != null) {
                    find = '"' + find + '"';
                    return ['Role value ' + find + ' can be set only once'];
                }
            };
        },

        resource_roleRequire: function (vals) {
            return function (value) {
                let count = _.countBy<any>(value, (obj) => {
                    return obj.role || 'none';
                });

                let find = _.find<any>(vals, (val) => {
                    if (count[val] == null) {
                        return true;
                    }
                    return count[val] === 0;
                });

                if (find != null) {
                    find = '"' + find + '"';
                    return ['Role value ' + find + ' must be specified'];
                }
            };
        },

        resource_roleId2_isOnlyInOne: function (value) {
            if (value == null) {
                return;
            }

            let count: any = _.countBy<any>(value, (resDescr) => {
                let count2: any = _.countBy<any>(resDescr.attrQuery, (obj) => {
                    return obj.role === 'id2';
                });
                return count2.true != null && count2.true > 0;
            });

            let ret = count.true != null && count.true > 1;
            if (ret) {
                return ['Role "id2" must be defined only for one Group'];
            }

            let ret1 = count.true != null && count.true > 0;
            if (ret1 && value.length > 1) {
                return ['When role "id2" is defined, only one Group can exist'];
            }

            return;
        },

        // as a whole - array of QueryResources   Unique ?   And notEmpty
        allTitlesDifferent: function (value) {
            if (value == null) {
                return;
            }

            let hasEmpty = false;

            let count = _.countBy<any>(value, (obj) => {
                if (obj.title == null) {
                    hasEmpty = true;
                } else {
                    let title = obj.title.trim();
                    if (title === '') {
                        hasEmpty = true;
                    }
                    return title;
                }
            });

            let find = _.find<any>(count, (val) => {
                return val > 1;
            });

            let ret = [];
            if (hasEmpty) {
                ret.push('Empty Titles prohibited');
            }

            if (find != null) {
                ret.push('Titles must be different');
            }

            if (ret.length > 0) {
                return ret;
            }
        },

        // as a whole - array of QueryResources
        allChildrenValid: function (value) {
            if (value == null) {
                return;
            }

            //LL:  pluck('valid')  returns nulls if no 'valid' field
            let find = _.chain(value)
                .pluck('valid')
                .find((v) => {
                    if (v != null) {
                        return v.valid !== true;
                    } else {
                        return false;
                    }
                })
                .value();

            //LL: for EU - validFilter
            //LL:  pluck('validFilter')  returns nulls if no 'validFilter' field
            if (find == null) {
                find = _.chain(value)
                    .pluck('validFilter')
                    .find((v) => {
                        if (v != null) {
                            return v.valid !== true;
                        } else {
                            return false;
                        }
                    })
                    .value();
            }

            if (find != null) {
                return ['Some Data Queries are not valid'];
            }
        },

        // as a whole - for obj (not array) QuerySchedulerData
        emptyQueryScheduler: function (value) {
            if (value == null) {
                return;
            }

            let attrQuery = value.attrQuery;
            if (attrQuery == null || attrQuery.length === 0) {
                return ['Data Query is empty'];
            }
        },

        // as a whole - for obj (not array) QuerySchedulerData
        childValid: function (value) {
            if (value == null) {
                return;
            }

            let valid = true;
            if (value['validQuery'] != null && value['validQuery'].valid != null) {
                valid = value['validQuery'].valid;
            }

            if (valid) {
                if (value['validFilter'] != null && value['validFilter'].valid != null) {
                    valid = value['validFilter'].valid;
                }
            }

            if (!valid) {
                return ['Data Query is not valid'];
            }
        }
    }
};
